import React, { useEffect, useState } from "react";

import { ReactFlowProvider } from "reactflow";
import DataMappingDiagram from "./DataMappingDiagram";
import { useSelector } from "react-redux";
import { selectUserInfo } from "@redux/slices/authSlice";


const DataMapping = ({ details, onButtonClick, onMappingAdded }) => {
  const [loaded, setLoaded] = useState(false);
  const userInfo = useSelector(selectUserInfo);
  const isUserRole = userInfo?.role?.toLowerCase() === "user";

  const onMappingAddedInChild = (mappings) => {
    if (onMappingAdded) {
      onMappingAdded(mappings);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 100);
  }, []);

  return (
    <div className="flex flex-col w-full h-[calc(100vh-120px)]">
      {/* Header */}
      <div className="mb-2 pt-2">
        <div className="text-base font-bold text-gray-900 tracking-tight">Data Mapping</div>
        <div className="text-xs text-gray-600 mt-0.5">
          Map Source and Destination fields to synchronize data.
        </div>
      </div>

      {/* Canvas — full width */}
      <div className="flex-1 min-h-0 text-gray-900">
        {loaded && (
          <ReactFlowProvider>
            <DataMappingDiagram details={details} interactive={!isUserRole} onMappingsAdded={onMappingAddedInChild} />
          </ReactFlowProvider>
        )}
      </div>
    </div>
  );
};

export default DataMapping;
